import API from './base';

class TeamMemberReviewAPI extends API {
  create(payload) {
    return this.post('/api/web/v1/team_member_reviews', payload);
  }
}

export default new TeamMemberReviewAPI();
